import styled from "styled-components";
import { prop } from "styled-tools";

export const ImageStyled = styled.img<{ $margin?: string }>`
  margin: ${prop("$margin")};
`;
